import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SidenavService } from "src/app/layout/sidenav/sidenav.service";
import { ApiService } from "src/app/services/api.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import endpoints from "src/app/helpers/endpoints";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { CommonService } from "src/app/services/common.service";
import { ErrorType } from "src/app/enums/error-type.enum";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { MapsService } from "src/app/services/maps.service";
import * as moment from "moment";
import { EventService } from "src/app/services/event.service";
import { CustomerDashboardService } from "../../services/customer-dashboard.service";
import { StorageService } from "src/app/services/storage.service";
import { ClaimActionsService } from "../../services/claim-actions.service";
import { PayoutInfoModalComponent } from "../modals/payment-info-modal/payout-info-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { ComplaintModalComponent } from "../modals/complaint-modal/complaint-modal.component";
import { Location } from "@angular/common";

enum SectionsNameEnum {
  ClaimFollowUp = "follow-up",
  ContactInformation = "contact-info",
  CustomerFees = "customer-fees",
  CustomerPayout = "customer-payout",
  TechniciaPayout = "technician-payout",
  ClaimDecision = "decision",
  AssignSupervisor = "assigned-supervisor",
  Diagnosis = "diagnosis",
  ClaimInfo = "claim-info",
  ClaimSummary = "claim-summary",
  Replacement = "order-replacement",
}

@Component({
  selector: "fury-view-claim",
  templateUrl: "./view-claim.component.html",
  styleUrls: ["./view-claim.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ViewClaimComponent implements OnInit, OnDestroy {
  @ViewChild("picker") picker: any;
  @ViewChild("picker1") picker1: any;
  userId = "";
  claimId = "";
  claimDetails: any;
  additionalQuestions: any;
  ngUnsubscribe = new Subject<void>();
  isEditClaim = false;
  validClaim = false;
  fetchSideMenu = false;
  shouldRefetchDocuments = false;
  claimSectionVisible: any;
  claimStatus: any[] = [];
  agents = [];
  services = [];
  editingTab = null;
  allSections = SectionsNameEnum;
  agentId = "";
  claimKpi: any;
  displayedRequestColumns: string[] = [
    "status",
    "assigned",
    "agreementNumber",
    "createdOn",
    "createdBy",
    "type",
    "priority",
    "request",
    "actions",
  ];

  displayedNotesColumns: string[] = [
    "status",
    "assigned",
    "agreementNumber",
    "createdOn",
    "createdBy",
    "priority",
    "notes",
    "actions",
  ];

  displayedFeedbackColumns: string[] = [
    "feedback",
    "reviewStatus",
    "assigned",
    "agreementNumber",
    "reviewSubmittedAt",
    "createdBy",
    "priority",
    "request",
    "actions",
  ];

  displayedPaymentDetailsColumns: string[] = [
    "transactionId",
    "amount",
    "cardType",
    "lastFourDigit",
  ];
  technicianAndCustomerStatus: string[] = ["Pending", "Paid"];
  technicianAndCustomerPaymentMethod: any[] = [
    {
      label: "Credit Card",
      value: "Credit Card",
    },
    {
      label: "Bank Payment",
      value: "Bank Payment",
    },
    {
      label: "Check Payment",
      value: "Check Payment",
    },
  ];
  claimOutcomeList: string[] = ["Repaired", "Replaced", "Payout", "Denied"];
  claimDecisionStatus: string[] = ["Approved", "Completed", "Denied"];
  outcomeScoreList: string[] = ["Satisfied", "Natural", "Not Satisfied"];
  warrantyList: string[] = ["No Warranty", "1 Year", "2 Year", "3 Year"];
  noteHistory = [];
  feedbackHistory = [];
  specialRequestHistory = [];
  maxDate = new Date().toISOString().split("T")[0];
  additionalQuestionForm!: FormGroup;
  additionalQuestion = [];
  firstQuestions = [];
  firstQuestionsForm!: FormGroup;
  claimQuestionForm!: FormGroup;
  claimQuestions = [];
  claimQuestionAnswers = [];

  datePicker = {
    disabled: false,
    showSpinners: true,
    showSeconds: false,
    touchUi: false,
    enableMeridian: false,
    minDate: new Date().toISOString().split("T")[0],
    stepHour: 1,
    stepMinute: 1,
    stepSecond: 1,
    color: "primary",
  };

  followUpForm = new FormGroup<any>({
    assignedFollowUpAgent: new FormControl("", [Validators.required]),
    followUpStatus: new FormControl("", [Validators.required]),
  });

  contactInfoForm = new FormGroup<any>({
    contactPerson: new FormControl("", [Validators.required]),
    contactPhoneNumber: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),
    ]),
    contactEmailAddress: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
    ]),
  });

  customerFeesForm = new FormGroup<any>({
    customerFees: new FormControl("", [Validators.required]),
    customerFeesNote: new FormControl("", [Validators.required]),
  });

  customerPayoutForm = new FormGroup<any>({
    customerPayoutNotes: new FormControl("", [Validators.required]),
    customerApproveAmount: new FormControl("", [Validators.required]),
    customerPayoutStatus: new FormControl("", [Validators.required]),
    customerPayoutDatetime: new FormControl("", [Validators.required]),
    customerPayoutPaymentMethod: new FormControl("", [Validators.required]),
    customerPayoutTransactionId: new FormControl("", [Validators.required]),
  });

  technicianPayoutForm = new FormGroup<any>({
    technicianPayoutNotes: new FormControl("", [Validators.required]),
    technicianPayout: new FormControl("", [Validators.required]),
    technicianPayoutStatus: new FormControl("", [Validators.required]),
    technicianPayoutDatetime: new FormControl("", [Validators.required]),
    technicianPayoutPaymentMethod: new FormControl("", [Validators.required]),
    technicianPayoutTransactionId: new FormControl("", [Validators.required]),
  });

  claimDecisionForm = new FormGroup<any>({
    claimOutcomeNote: new FormControl("", [Validators.required]),
    claimOutcome: new FormControl("", [Validators.required]),
    outcomeStatus: new FormControl("", [Validators.required]),
    outcomeScore: new FormControl("", [Validators.required]),
  });
  assignSupervisorForm = new FormGroup<any>({
    assignedSupervisorNote: new FormControl("", [Validators.required]),
    assignedSupervisor: new FormControl("", [Validators.required]),
  });

  diagnosisForm = new FormGroup({
    recommendation: new FormControl("", [Validators.required]),
    documentNote: new FormControl("", [Validators.required]),
    costOfRepairLabor: new FormControl("", [Validators.required]),
    costOfRepairParts: new FormControl("", [Validators.required]),
    costOfRepairTotal: new FormControl("", [Validators.required]),
    ageOfItem: new FormControl("", [Validators.required]),
    itemType: new FormControl("", [Validators.required]),
    brand: new FormControl("", [Validators.required]),
    model: new FormControl("", [Validators.required]),
    serial: new FormControl("", [Validators.required]),
    color: new FormControl("", [Validators.required]),
    size: new FormControl("", [Validators.required]),
    notes: new FormControl("", [Validators.required]),
    whatWasCompleted: new FormControl("", [Validators.required]),
    // diagnosisTimeStamp: new FormControl(null, [Validators.required]),
  });

  claimInfoForm = new FormGroup({
    copaymentFee: new FormControl("", [Validators.required]),
    copaymentNotes: new FormControl("", [Validators.required]),
    statusNotes: new FormControl("", [Validators.required]),
    emergency: new FormControl(false, [Validators.required]),
    assignedConcierge: new FormControl("", [Validators.required]),
    warrantyPeriod: new FormControl("", [Validators.required]),
    outcomeScore: new FormControl("", [Validators.required]),
    claimOutcomeNote: new FormControl("", [Validators.required]),
  });

  claimSummaryForm = new FormGroup({
    claimSummaryNote: new FormControl("", [Validators.required]),
    issueNote: new FormControl("", [Validators.required]),
    priorIsuueInformation: new FormControl("", [Validators.required]),
    ninetyDayLimitation: new FormControl("", [Validators.required]),
  });
  orderReplacementForm = new FormGroup({
    orderedFrom: new FormControl("", [Validators.required]),
    orderedDate: new FormControl(null, [Validators.required]),
    tracking: new FormControl("", [Validators.required]),
    deliveryDate: new FormControl(null, [Validators.required]),
    ageOfItem: new FormControl("", [Validators.required]),
    itemType: new FormControl("", [Validators.required]),
    brand: new FormControl("", [Validators.required]),
    model: new FormControl("", [Validators.required]),
    serial: new FormControl("", [Validators.required]),
    color: new FormControl("", [Validators.required]),
    size: new FormControl("", [Validators.required]),
    notes: new FormControl("", [Validators.required]),
    hallaway: new FormControl(false, [Validators.required]),
    itemCost: new FormControl("", [Validators.required]),
    installationCost: new FormControl("", [Validators.required]),
    hallawayCost: new FormControl("", [Validators.required]),
    outcome: new FormControl("", [Validators.required]),
    completedNote: new FormControl("", [Validators.required]),
  });

  constructor(
    private sidenavService: SidenavService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private apiService: ApiService,
    public commonService: CommonService,
    private mapService: MapsService,
    private eventService: EventService,
    private customerDashboardService: CustomerDashboardService,
    private storageService: StorageService,
    private claimActionsService: ClaimActionsService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private location: Location,
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.sidenavService.close();
    }, 0);
    this.additionalQuestionForm = this.fb.group({});
    this.firstQuestionsForm = this.fb.group({});
    this.claimQuestionForm = this.fb.group({});
    this.userId = this.activateRoute.snapshot.params["id"];
    this.claimId = this.activateRoute.snapshot.params["claimId"];
    this.customerDashboardService.shouldFetchSpecialRequestList$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: boolean) => {
          if (res) this.getFileClaimDocumentsHistories();
        },
      });
    this.customerDashboardService.shouldFetchNoteList$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: boolean) => {
          if (res) this.getFileClaimDocumentsHistories();
        },
      });

    if (!this.claimId) return;
    this.fetchFeedbackData();
    this.getAllClaimQuestionAnswer();
    this.getClaimDetails(false);
    this.getAdditionalQuestionTypes();
    this.getFileClaimDocumentsHistories();
    this.getServices();
    this.agentId = this.storageService.getUser()?.userId;
    this.getClaimViewKpi();
    this.shouldFetchClaims();
    this.eventService.getClaimStatus$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((status: any[]) => {
        this.claimStatus = status;
      });
    this.getAgents();
  }

  getAgents() {
    this.customerDashboardService.getAgent$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((agents) => {
        if (agents?.length) {
          this.agents = agents;
        }
      });
  }

  redirectToDashboard() {
    this.router.navigateByUrl(`customer-dashboard/${this.userId}`);
  }

  getClaimViewKpi() {
    this.apiService
      .get(endpoints.customerDashboard.getClaimViewKpi(this.claimId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.claimKpi = res?.body;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
        },
      });
  }

  getClaimDetails(fetchLog = true) {
    this.customerDashboardService.setClaimChangesLogList(false);
    this.apiService
      .get(endpoints.customerDashboard.getClaimDetails(this.claimId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.claimDetails = res.body;
            const optionalTitle = [];
            const coverItemsTile = [];
            this.additionalQuestion = res.body?.claim?.additionalQuestions;
            this.firstQuestions = res.body?.claim?.firstQestions;
            this.claimQuestions = res.body?.claim?.answerDetails;
            this.claimSectionVisible = res.body?.availableSectionData;
            if (this.additionalQuestion.length) this.dynamicAdditionalForm();
            if (this.firstQuestions.length) this.dynamicFirstQuestionForm();
            if (this.claimQuestions.length) this.dynamicClaimQuestion();
            this.claimDetails?.claim?.agreementDetail?.orderAdditionalItems?.forEach(
              (ele) => {
                if (ele?.orderCoveredItemTitle) {
                  optionalTitle.push(ele?.orderCoveredItemTitle);
                }
              }
            );

            this.claimDetails?.claim?.agreementDetail?.orderPlanDetail?.orderMainPlanCoveredItems?.forEach(
              (ele) => {
                if (ele) {
                  coverItemsTile.push(ele);
                }
              }
            );

            if (optionalTitle.length) {
              Object.assign(this.claimDetails?.claim?.agreementDetail, {
                optionalItemsTitles: optionalTitle,
              });
            }

            if (coverItemsTile.length) {
              Object.assign(this.claimDetails?.claim?.agreementDetail, {
                coveredItemsTitles: coverItemsTile,
              });
            }

            this.validClaim = true;
            this.setFormValues();
            if(fetchLog){
              this.customerDashboardService.setClaimChangesLogList(true);
            }
        
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
          this.validClaim = false;
        },
      });
  }
  dynamicAdditionalForm() {
    this.additionalQuestion.forEach((question) => {
      const validators = question?.question_details.isRequired
        ? [Validators.required]
        : [];
      const control = this.fb.control(question?.answer, validators);
      this.additionalQuestionForm.addControl(
        question?.question_details.additionalQuestionId,
        control
      );
    });
  }
  dynamicFirstQuestionForm() {
    this.firstQuestions.forEach((question, index) => {
      const validators = question?.question_details?.isRequired
        ? [Validators.required]
        : [];
      const control = this.fb.control(question?.answer, validators);
      this.firstQuestionsForm.addControl(
        question?.question_details?.firstQuestionId,
        control
      );
    });
  }
  dynamicClaimQuestion() {
    this.claimQuestions.forEach((question) => {
      const claimQuestionAnswerIds =
        question?.claim_question_answer_details.map(
          (answer: any) => answer?.claimQuestionAnswerId
        );
      const control = this.fb.control(claimQuestionAnswerIds, [
        Validators.required,
      ]);
      this.claimQuestionForm.addControl(
        question?.claim_question_answer_details[0].quetion.claimQuestionId,
        control
      );
    });
  }

  getFileClaimDocumentsHistories() {
    this.apiService
      .get(
        endpoints.customerDashboard.getFileClaimDocumentsHistories(this.claimId)
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body?.claim) {
            this.noteHistory = res.body?.claim?.noteHistory || [];
            this.feedbackHistory = res.body?.claim?.feedbackHistory || [];
            this.specialRequestHistory =
              res.body?.claim?.specialRequestHistory || [];
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
          this.validClaim = false;
        },
      });
  }

  setFormValues(data?: any) {
    this.setFollowUp();
    this.setContactInfo();
    this.setCustomerFees();
    this.setCustomerPayout();
    this.setTechnicianPayout();
    this.setClaimDecision();
    this.setAssignSuperVisor();
    this.setDiagnosis();
    this.setClaimInfo();
    this.setClaimSummary();
    this.setReplacement(data);
  }
  setReplacement(data: any) {
    this.orderReplacementForm.patchValue(data);
    this.orderReplacementForm.patchValue({
      orderedDate: new Date(this.commonService.convertDate(data?.orderedDate)),
      deliveryDate: new Date(
        this.commonService.convertDate(data?.deliveryDate)
      ),
    });
  }

  setFollowUp() {
    this.followUpForm.setValue({
      assignedFollowUpAgent:
        this.claimDetails?.claim?.additionalInfo?.assignedFollowUpAgent
          ?.userId || null,
      followUpStatus:
        this.claimDetails?.claim?.additionalInfo?.followUpStatus || null,
    });
  }
  setContactInfo() {
    this.contactInfoForm.setValue({
      contactPerson:
        this.claimDetails?.claim?.additionalInfo?.contactPerson || null,
      contactPhoneNumber:
        this.claimDetails?.claim?.additionalInfo?.contactPhoneNumber || null,
      contactEmailAddress:
        this.claimDetails?.claim?.additionalInfo?.contactEmailAddress || null,
    });
  }
  setCustomerFees() {
    this.customerFeesForm.setValue({
      customerFees: this.claimDetails?.claim?.claimPayout?.customerFees || null,
      customerFeesNote:
        this.claimDetails?.claim?.claimPayout?.customerFeesNote || null,
    });
  }

  setCustomerPayout() {
    this.customerPayoutForm.setValue({
      customerPayoutNotes:
        this.claimDetails?.claim?.claimPayout?.customerPayoutNotes || null,
      customerApproveAmount:
        this.claimDetails?.claim?.claimPayout?.customerApprovedAmount || null,
      customerPayoutStatus:
        this.claimDetails?.claim?.claimPayout?.customerPayoutStatus || null,
      customerPayoutDatetime:
        new Date(
          this.claimDetails?.claim?.claimPayout?.customerPayoutDatetime
        ) || null,
      customerPayoutPaymentMethod:
        this.claimDetails?.claim?.claimPayout?.customerPayoutPaymentMethod ||
        null,
      customerPayoutTransactionId:
        this.claimDetails?.claim?.claimPayout?.customerPayoutTransactionId ||
        null,
    });
  }

  setTechnicianPayout() {
    this.technicianPayoutForm.setValue({
      technicianPayoutNotes:
        this.claimDetails?.claim?.claimPayout?.technicianPayoutNotes || null,
      technicianPayout:
        this.claimDetails?.claim?.claimPayout?.technicianPayout || null,
      technicianPayoutStatus:
        this.claimDetails?.claim?.claimPayout?.technicianPayoutStatus || null,
      technicianPayoutDatetime:
        new Date(
          this.claimDetails?.claim?.claimPayout?.technicianPayoutDatetime
        ) || null,
      technicianPayoutPaymentMethod:
        this.claimDetails?.claim?.claimPayout?.technicianPayoutPaymentMethod ||
        null,
      technicianPayoutTransactionId:
        this.claimDetails?.claim?.claimPayout?.technicianPayoutTransactionId ||
        null,
    });
  }

  setClaimDecision() {
    this.claimDecisionForm.setValue({
      claimOutcomeNote:
        this.claimDetails?.claim?.decision?.claimOutcomeNote || null,
      claimOutcome: this.claimDetails?.claim?.decision?.claimOutcome || null,
      outcomeStatus: this.claimDetails?.claim?.decision?.outcomeStatus || null,
      outcomeScore: this.claimDetails?.claim?.decision?.outcomeScore || null,
    });
  }
  setAssignSuperVisor() {
    this.assignSupervisorForm.setValue({
      assignedSupervisorNote:
        this.claimDetails?.claim?.additionalInfo?.assignedSupervisorNote ||
        null,
      assignedSupervisor:
        this.claimDetails?.claim?.additionalInfo?.assignedSupervisor?.userId ||
        null,
    });
  }

  setDiagnosis() {
    this.diagnosisForm.setValue({
      notes: this.claimDetails?.claim?.diagnosis?.notes || null,
      recommendation:
        this.claimDetails?.claim?.diagnosis?.recommendation || null,
      costOfRepairParts:
        this.claimDetails?.claim?.diagnosis?.costOfRepair?.parts || null,
      costOfRepairLabor:
        this.claimDetails?.claim?.diagnosis?.costOfRepair?.labor || null,
      costOfRepairTotal:
        this.claimDetails?.claim?.diagnosis?.costOfRepair?.total || null,
      ageOfItem: this.claimDetails?.claim?.diagnosis?.ageOfItem || null,
      itemType: this.claimDetails?.claim?.diagnosis?.itemType || null,
      brand: this.claimDetails?.claim?.diagnosis?.brand || null,
      model: this.claimDetails?.claim?.diagnosis?.model || null,
      serial: this.claimDetails?.claim?.diagnosis?.serial || null,
      color: this.claimDetails?.claim?.diagnosis?.color || null,
      size: this.claimDetails?.claim?.diagnosis?.size || null,
      documentNote: this.claimDetails?.claim?.diagnosis?.documentNote || null,
      // diagnosisTimeStamp: new Date(this.claimDetails?.claim?.diagnosis?.createdAt),
      whatWasCompleted:
        this.claimDetails?.claim?.diagnosis?.whatWasCompleted || null,
    });
  }

  setClaimInfo() {
    this.claimInfoForm.setValue({
      copaymentFee: this.claimDetails?.claim?.copaymentFee || null,
      emergency: this.claimDetails?.claim?.additionalInfo?.emergency || null,
      copaymentNotes: this.claimDetails?.claim?.copayNotes || null,
      statusNotes: this.claimDetails?.claim?.statusNotes || null,
      assignedConcierge:
        this.claimDetails?.claim?.additionalInfo?.assignedConcierge?.userId ||
        null,
      warrantyPeriod:
        this.claimDetails?.claim?.additionalInfo?.warrantyPeriod || null,
      outcomeScore: this.claimDetails?.claim?.decision?.outcomeScore || null,
      claimOutcomeNote:
        this.claimDetails?.claim?.decision?.claimOutcomeNote || null,
    });
  }
  setClaimSummary() {
    this.claimSummaryForm.setValue({
      claimSummaryNote:
        this.claimDetails?.claim?.additionalInfo?.claimSummaryNote || null,
      issueNote: this.claimDetails?.claim?.additionalInfo?.issueNote || null,
      priorIsuueInformation:
        this.claimDetails?.claim?.additionalInfo?.priorIssueInformation || null,
      ninetyDayLimitation:
        this.claimDetails?.claim?.additionalInfo?.ninetyDayLimitation.toString() ||
        null,
    });
  }
  editSection(section: string, data?: any) {
    this.setFormValues(data);
    this.editingTab = section;
  }

  saveSection(section: string) {
    switch (section) {
      case this.allSections.ClaimFollowUp: {
        this.submitClaimFollowup();
        break;
      }

      case this.allSections.ContactInformation: {
        this.submitContactInfo();
        break;
      }

      case this.allSections.CustomerFees: {
        this.submitCustomerFees();
        break;
      }

      case this.allSections.CustomerPayout: {
        this.submitCustomerPayout();
        break;
      }

      case this.allSections.TechniciaPayout: {
        this.submitTechnicianPayout();
        break;
      }

      case this.allSections.ClaimDecision: {
        this.submitClaimDecision();
        break;
      }

      case this.allSections.AssignSupervisor: {
        this.submitAssignSupervisor();
        break;
      }

      case this.allSections.Diagnosis: {
        this.submitDiagnosis();
        break;
      }

      case this.allSections.ClaimInfo: {
        this.submitClaimInfo();
        break;
      }

      case this.allSections.ClaimSummary: {
        this.submitClaimSummary();
        break;
      }
    }
  }

  submitClaimFollowup() {
    if (this.followUpForm.invalid) {
      this.followUpForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    const payload = {
      assignedFollowUpAgent: this.followUpForm.get("assignedFollowUpAgent")
        .value,
      followUpStatus: this.followUpForm.get("followUpStatus").value,
      agentId: this.agentId,
    };
    this.updateClaim(this.allSections.ClaimFollowUp, payload);
  }

  submitContactInfo() {
    if (this.contactInfoForm.invalid) {
      this.contactInfoForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    const payload = {
      contactPerson: this.contactInfoForm.get("contactPerson").value,
      contactPhoneNumber: this.contactInfoForm.get("contactPhoneNumber").value,
      contactEmailAddress: this.contactInfoForm.get("contactEmailAddress")
        .value,
      agentId: this.agentId,
    };
    this.updateClaim(this.allSections.ContactInformation, payload);
  }
  submitCustomerFees() {
    if (this.customerFeesForm.invalid) {
      this.customerFeesForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    const payload = {
      customerFees: this.customerFeesForm.get("customerFees").value,
      customerFeesNote: this.customerFeesForm.get("customerFeesNote").value,
      agentId: this.agentId,
    };
    this.updateClaim(this.allSections.CustomerFees, payload);
  }

  submitCustomerPayout() {
    if (this.customerPayoutForm.invalid) {
      this.customerPayoutForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    let payload = this.customerPayoutForm.value;
    payload = {...payload, agentId: this.agentId};
    (payload.customerPayoutDatetime = moment(
      this.customerPayoutForm.get("customerPayoutDatetime").value
    ).format("YYYY-MM-DD HH:mm:ss"));
      this.updateClaim(this.allSections.CustomerPayout, payload);
  }
  submitTechnicianPayout() {
    if (this.technicianPayoutForm.invalid) {
      this.technicianPayoutForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    let payload = this.technicianPayoutForm.value;
    payload = {...payload, agentId: this.agentId};
    payload.technicianPayoutDatetime = moment(
      this.technicianPayoutForm.get("technicianPayoutDatetime").value
    ).format("YYYY-MM-DD HH:mm:ss");
      this.updateClaim(this.allSections.TechniciaPayout, payload);
  }
  submitClaimDecision() {
    if (this.claimDecisionForm.invalid) {
      this.claimDecisionForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    const payload = this.claimDecisionForm.value;
    (payload.agentId = this.agentId),
      this.updateClaim(this.allSections.ClaimDecision, payload);
  }
  submitAssignSupervisor() {
    if (this.assignSupervisorForm.invalid) {
      this.assignSupervisorForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    const payload = this.assignSupervisorForm.value;
    (payload.agentId = this.agentId),
      this.updateClaim(this.allSections.AssignSupervisor, payload);
  }
  submitDiagnosis() {
    if (this.diagnosisForm.invalid) {
      this.diagnosisForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    const payload = new FormData();
    payload.append("recommendation", this.diagnosisForm.value.recommendation);
    payload.append(
      "costOfRepair[labor]",
      this.diagnosisForm.value.costOfRepairLabor
    );
    payload.append(
      "costOfRepair[parts]",
      this.diagnosisForm.value.costOfRepairParts
    );
    payload.append(
      "costOfRepair[total]",
      this.diagnosisForm.value.costOfRepairTotal
    );
    payload.append("ageOfItem", this.diagnosisForm.value.ageOfItem);
    payload.append("itemType", this.diagnosisForm.value.itemType);
    payload.append("brand", this.diagnosisForm.value.brand);
    payload.append("model", this.diagnosisForm.value.model);
    payload.append("serial", this.diagnosisForm.value.serial);
    payload.append("color", this.diagnosisForm.value.color);
    payload.append("size", this.diagnosisForm.value.size);
    payload.append("notes", this.diagnosisForm.value.notes);
    payload.append("documentNote", this.diagnosisForm.value.documentNote);
    payload.append(
      "whatWasCompleted",
      this.diagnosisForm.value.whatWasCompleted
    );
    // payload.append(
    //   "diagnosisTimeStamp",
    //   moment(this.diagnosisForm.get("diagnosisTimeStamp").value).format(
    //     "YYYY-MM-DD HH:mm:ss"
    //   )
    // );
    payload.append("agentId", this.agentId);

    this.updateClaim(this.allSections.Diagnosis, payload);
  }

  submitClaimInfo() {
    if (this.claimInfoForm.invalid) {
      this.claimInfoForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    let payload: any = this.claimInfoForm.value;
    payload = {...payload, agentId: this.agentId};

    this.updateClaim(this.allSections.ClaimInfo, payload);
  }
  submitClaimSummary() {
    if (
      this.claimSummaryForm.invalid ||
      this.additionalQuestionForm.invalid ||
      this.claimQuestionForm.invalid ||
      this.firstQuestionsForm.invalid
    ) {
      this.claimSummaryForm.markAllAsTouched();
      this.additionalQuestionForm.markAllAsTouched();
      this.claimQuestionForm.markAllAsTouched();
      this.firstQuestionsForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    const convertAdditionalQuestion = Object.keys(
      this.additionalQuestionForm.value
    )
      .filter(
        (key) =>
          this.additionalQuestionForm.value[key] !== undefined &&
          this.additionalQuestionForm.value[key] !== null &&
          this.additionalQuestionForm.value[key] !== ""
      )
      .map((key) => ({
        additionalQuestionId: key,
        answer: this.additionalQuestionForm.value[key],
      }));

    const convertFirstQuestion = Object.keys(this.firstQuestionsForm.value)
      .filter(
        (key) =>
          this.firstQuestionsForm.value[key] !== undefined &&
          this.firstQuestionsForm.value[key] !== null &&
          this.firstQuestionsForm.value[key] !== ""
      )
      .map((key: any) => ({
        firstQuestionId: key,
        answer: this.firstQuestionsForm.value[key],
      }));

    const claimAnswerId = Object.keys(this.claimQuestionForm.value).map(
      (key: any) => ({
        questionId: key,
        answerId: this.claimQuestionForm.value[key],
      })
    );

    let payload: any = this.claimSummaryForm.value;
    payload.additionalQuestion = convertAdditionalQuestion;
    payload.firstQuestion = convertFirstQuestion;
    payload.claimAnswerId = claimAnswerId;
    payload = {...payload, agentId: this.agentId};

    this.updateClaim(this.allSections.ClaimSummary, payload);
  }

  cancelSection(section) {
    this.editingTab = null;
    this.setFormValues();
  }

  getAdditionalQuestionTypes() {
    this.apiService
      .get(endpoints.customerDashboard.getAdditionalQuestionTypes)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.additionalQuestions = res.body;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
        },
      });
  }

  editClaim() {
    this.isEditClaim = true;
  }

  handleEditRequest(rowData) {
    const requestId = rowData?.specialRequestId;
    if (!requestId || !this.userId) return;
    this.customerDashboardService.handleSpecialRequest(this.userId, requestId);
  }

  handleViewRequest(rowData: any) {
    const requestId = rowData?.specialRequestId;
    if (!requestId || !this.userId) return;
    this.customerDashboardService.handleSpecialRequest(
      this.userId,
      requestId,
      true
    );
  }

  handleEditFeedback(rowData) {
    const reviewId = rowData?.reviewId;
    if (!reviewId || !this.userId) return;
    this.customerDashboardService.handleFeedbackRequest(this.userId, reviewId, false, null, null);
  }
  handleViewFeedback(rowData: any) {
    const reviewId = rowData?.reviewId;
    if (!reviewId || !this.userId) return;
    this.customerDashboardService.handleFeedbackRequest(this.userId, reviewId, true, null, null);
  }

  handleEditNotes(rowData: any) {
    const noteId = rowData?.noteId;
    if (!noteId || !this.userId) return;
    this.customerDashboardService.handleAddNotes(this.userId, noteId, false, null, null);
  }
  handleViewNotes(rowData: any) {
    const noteId = rowData?.noteId;
    if (!noteId || !this.userId) return;
    this.customerDashboardService.handleAddNotes(this.userId, noteId, true, null, null);
  }

  updateClaim(section: string, payload: any) {
    this.fetchSideMenu = false;
    const apiMethod =
      section === this.allSections.Diagnosis
        ? this.apiService.postMultiData(
            endpoints.customerDashboard.updateFileClaim(this.claimId, section),
            payload
          )
        : this.apiService.patch(
            endpoints.customerDashboard.updateFileClaim(this.claimId, section),
            payload
          );
    apiMethod.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: HttpResponse<any>) => {
        this.isEditClaim = false;
        this.fetchSideMenu = true;
        this.getClaimDetails();
      },
      error: (err: HttpErrorResponse) => {
        this.apiService.alert(
          err.error?.message || err?.message,
          ErrorType.Error
        );
      },
    });
  }

  handlePolicyClick(serviceAgreementPdf) {
    if (!serviceAgreementPdf) {
      this.apiService.alert("Document Not Found", ErrorType.Error);
      return;
    }
    window.open(serviceAgreementPdf, "_blank");
  }

  handleDateOpen() {
    this.picker.open();
    setTimeout(() => {
      this.picker.value =
        this.claimDetails?.claim?.claimPayout?.customerPayoutDatetime;
    }, 1500);
  }

  getServices() {
    this.apiService
      .get(endpoints.partners.serviceProvider.getServices)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.services = res.body?.services;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }

  openActionModal(modalName: string,) {
    this.claimActionsService.openActionModal(
      this.claimId,
      modalName,
      this.services,
      this.claimDetails?.claim?.propertyAddress?.zip,
      this.claimDetails?.claim?.coveredItemId
    );
  }

  handleAddNotes() {
    if (
      !this.claimDetails?.claim?.agreementDetail?.agreementNumber ||
      !this.userId ||
      !this.claimId
    )
      return;
    this.customerDashboardService.handleAddNotes(this.userId, null, false, this.claimDetails?.claim?.agreementDetail?.agreementNumber, this.claimId);
  }

  shouldFetchClaims() {
    this.claimActionsService.shouldViewFetchClaims$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.shouldRefetchDocuments = false;
        this.fetchSideMenu = false;
        if (res) {
          if (!this.claimId) return;
          this.getClaimDetails();
          this.getAdditionalQuestionTypes();
          this.shouldRefetchDocuments = true;
          this.fetchSideMenu = true;
          this.getClaimViewKpi();
        }
      });
  }

  handleSendEmail() {
    this.claimActionsService.updateFileClaimInfo(
      this.claimId,
      null,
      "sendAnEmail"
    );
  }

  redirectChangeStatusPage() {
    this.router.navigateByUrl(
      `customer-dashboard/${this.userId}/claim-status/${this.claimId}`
    );
  }

  handleAddSpecialRequest() {
    if (
      !this.claimDetails?.claim?.agreementDetail?.agreementNumber ||
      !this.userId ||
      !this.claimId
    )
      return;
    this.customerDashboardService.handleSpecialRequest(
      this.userId,
      null,
      false,
      this.claimId,
      this.claimDetails?.claim?.agreementDetail?.agreementNumber
    );
  }

  handleAddFeedback() {
    if (
      !this.claimDetails?.claim?.agreementDetail?.agreementNumber ||
      !this.userId ||
      !this.claimId
    )
      return;
      this.customerDashboardService.handleFeedbackRequest(this.userId, null, false, this.claimId, this.claimDetails?.claim?.agreementDetail?.agreementNumber);
  }

  fetchFeedbackData() {
    this.customerDashboardService.shouldViewFetchFeedback$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.getFileClaimDocumentsHistories();
        }
      });
  }

  handleAddComplaint() {
    const data = { claimId: this.claimId, userId: this.userId };

    this.dialog
      .open(ComplaintModalComponent, {
        data: data,
        width: "600px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (!res?.actionValue) return;
      });
  }

  handlePaymentInfo() {
    this.dialog
      .open(PayoutInfoModalComponent, {
        data: this.claimDetails?.paymentDetails,
        width: "600px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: any) => {});
  }
  getAllClaimQuestionAnswer() {
    this.apiService
      .get(
        `${endpoints.customerDashboard.getClaimQuestionAnswers}?page=1&size=9999`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          this.claimQuestionAnswers =
            res.body?.claimQuestions?.data[0]?.questionAnswers;
        }
      });
  }
  updateOrderReplacement(claimReplacementId: string) {
    if (this.orderReplacementForm.invalid) {
      this.orderReplacementForm.markAllAsTouched();
      return;
    }

    let payload: any = this.orderReplacementForm.value;
    payload.orderedDate = moment(
      this.orderReplacementForm.value?.orderedDate
    ).format("YYYY-MM-DD HH:mm:ss");
    payload.deliveryDate = moment(
      this.orderReplacementForm.value?.deliveryDate
    ).format("YYYY-MM-DD HH:mm:ss");
    payload.agentId = this.agentId;
    this.apiService
      .patch(
        endpoints.customerDashboard.updateClaimReplacement(claimReplacementId),
        payload
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.editingTab = null;
          this.isEditClaim = false;
          this.getClaimDetails();
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  back(){
    this.location.back();
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
